import styled from "styled-components"

export const DataResultsWrapper = styled.section`
  margin-bottom: 16px;
`